module.exports = __webpack_public_path__ + "static/ro-workshops-3-b331508a12d2d2b5bb297b30b8722bd6.jpg";